import { render, staticRenderFns } from "./CardTitleContent.vue?vue&type=template&id=991d1dca"
import script from "./CardTitleContent.vue?vue&type=script&lang=js"
export * from "./CardTitleContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports